<template>
  <div class="home">
    <RiClothesCard style="margin-top: 90px;">
      <template>
        <RiClothesLogo style="max-width: 512px; margin: 8px;" />
      </template>
    </RiClothesCard>

    <RiClothesCard style="margin-top: 32px; margin-bottom: 8px;">
      <template>
        <RiClothesText textType="high" textSize="1.7rem" style="padding-left: 8px;">・ RiClothes</RiClothesText>
        <RiClothesText textType="medium" style="padding-left: 4px; padding-top:4px;">VRChat関連のアイテムを販売 / 配布 するバーチャルブランド</RiClothesText>
        <RiClothesText textType="medium" style="padding-left: 4px;">3Dモデル系(服, アイテムとか)とプログラム系(Unity拡張とか)で何でもあり</RiClothesText>

        <RiClothesText textType="high" textSize="1.6rem" style="padding-left: 8px; padding-top: 12px;">・ コンセプトとか</RiClothesText>
        <RiClothesText textType="medium" style="padding-left: 4px; padding-top:4px;">特になし！</RiClothesText>

        <RiClothesText textType="high" textSize="1.6rem" style="padding-left: 8px; padding-top: 12px;">・ 販売 / 配布してるもの</RiClothesText>
        <div style="text-align: left; margin-top: 8px;">
          <RiClothesButton text="販売物/配布物" buttonType="outline" color="blue" router_to="/product"></RiClothesButton>
          <RiClothesButton text="BOOTHのストアページ(外部サイト)" buttonType="outline" color="red" href="https://riku1227.booth.pm/"></RiClothesButton>
        </div>

        <RiClothesText textType="high" textSize="1.6rem" style="padding-left: 8px; padding-top: 12px;">・ 他関連サイト</RiClothesText>
        <div style="text-align: left; margin-top: 8px;">
          <RiClothesButton text="ホームページ" buttonType="outline" color="purple" href="https://riku1227.com"></RiClothesButton>
          <RiClothesButton style="font-size: 16px;" text="Twitter" buttonType="outline" color="cyan" href="https://twitter.com/_riku1227_"></RiClothesButton>
          <RiClothesButton style="font-size: 16px;" text="GitHub" buttonType="outline" color="green" href="https://github.com/riku1227"></RiClothesButton>
        </div>
      </template>
    </RiClothesCard>
  </div>
</template>

<script>
// @ is an alias to /src
import RiClothesButton from "@/components/RiClothesButton.vue";
import RiClothesText from "@/components/RiClothesText.vue";
import RiClothesCard from "@/components/RiClothesCard.vue";
import RiClothesLogo from "@/components/RiClothesLogo.vue";

export default {
  name: "Home",
  components: {
    RiClothesButton,
    RiClothesText,
    RiClothesCard,
    RiClothesLogo
  },
  methods: {
    testFunction: function() {
      this.$root.config.isDarkTheme = !this.$root.config.isDarkTheme;
    }
  },
  mounted() {
    document.title = `RiClothes Website`;
  }
};
</script>
